import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { banners } from '@/mocks/videos';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const total = banners.length;

  const goNext = useCallback(() => {
    setCurrent((prev) => (prev + 1) % total);
  }, [total]);

  const goPrev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + total) % total);
  }, [total]);

  useEffect(() => {
    const timer = setInterval(goNext, 5000);
    return () => clearInterval(timer);
  }, [goNext]);

  const banner = banners[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center transition-all duration-700"
        style={{ backgroundImage: `url(${banner.image})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50" />

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-3xl mx-auto text-center">
            <span className="inline-block px-3 py-1 rounded-full bg-white/20 backdrop-blur-sm text-white text-xs font-medium mb-4">
              {banner.category}
            </span>
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold font-heading text-white mb-4 leading-tight">
              {banner.title}
            </h2>
            <p className="text-sm md:text-base text-white/80 mb-6 max-w-xl mx-auto">
              {banner.description}
            </p>
            <Link
              to={banner.url}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-fill text-lg"></i>
              立即观看
            </Link>
          </div>
        </div>
      </div>

      <button
        onClick={goPrev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/35 backdrop-blur-sm text-white transition-all cursor-pointer"
        aria-label="上一个"
      >
        <i className="ri-arrow-left-s-line text-lg md:text-xl"></i>
      </button>
      <button
        onClick={goNext}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/35 backdrop-blur-sm text-white transition-all cursor-pointer"
        aria-label="下一个"
      >
        <i className="ri-arrow-right-s-line text-lg md:text-xl"></i>
      </button>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {banners.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              index === current
                ? 'w-6 bg-white'
                : 'bg-white/40 hover:bg-white/60'
            }`}
            aria-label={`切换到第${index + 1}张`}
          />
        ))}
      </div>
    </section>
  );
}